var render = function render(_c,_vm){return _c('button',_vm._g({ref:_vm.data.ref,staticClass:"burger",class:[_vm.data.class, _vm.data.staticClass, { 'is-active': _vm.props.active }],style:([_vm.data.style, _vm.data.staticStyle])},_vm.listeners),[_c('span',{staticClass:"burger__lines"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }